// src/Text.tsx
import styled from "@emotion/styled";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var Wrapper = styled.span(
  ({
    theme,
    color,
    maxWidth,
    noOverflow,
    noWrap,
    numberOfLines,
    strikethrough,
    textAlign = "left",
    underline,
    variant,
    width,
    hasTabularNums
  }) => [
    variant && theme.typography[variant],
    {
      textAlign,
      width,
      maxWidth,
      color
    },
    numberOfLines && {
      display: "-webkit-box",
      overflow: "hidden",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: numberOfLines
    },
    noOverflow && theme.typography.noOverflow,
    noWrap && theme.typography.noWrap,
    underline && theme.typography.underline[underline],
    strikethrough && { textDecoration: "line-through" },
    hasTabularNums && { fontVariantNumeric: "tabular-nums" }
  ]
);
var Text = forwardRef(
  ({ children, isSensitive, ...props }, ref) => /* @__PURE__ */ jsx(Wrapper, {
    ref,
    ...props,
    className: isSensitive ? `_lr-hide ${props.className || ""}` : props.className,
    children
  })
);

// src/TextStencil.tsx
import { useTranslation } from "@brexhq/i18n";
import { GenericStencil } from "@brexhq/metal-generic-stencil";
import { VStack } from "@brexhq/metal-layout";
import styled2 from "@emotion/styled";
import { jsx as jsx2 } from "react/jsx-runtime";
var HiddenTextContainer = styled2.div({
  opacity: 0
});
var TextStencil = ({
  numberOfLines = 1,
  variant,
  width = "100%"
}) => {
  const { t } = useTranslation("text~web");
  const lines = new Array(numberOfLines).fill(void 0).map((_, i) => /* @__PURE__ */ jsx2(GenericStencil, {
    height: "100%",
    width,
    children: /* @__PURE__ */ jsx2(HiddenTextContainer, {
      "aria-hidden": true,
      children: /* @__PURE__ */ jsx2(Text, {
        variant,
        children: t("loading")
      })
    })
  }, `text-stencil-line-${i}`));
  return /* @__PURE__ */ jsx2(VStack, {
    spacing: 4,
    children: lines
  });
};

// src/index.ts
var TextWithNamespace = Text;
TextWithNamespace.Stencil = TextStencil;
var Text2 = TextWithNamespace;
export {
  Text2 as Text
};
